import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-partner-header',
  templateUrl: './partner-header.component.html',
  styleUrl: './partner-header.component.less'
})
export class PartnerHeaderComponent implements OnInit {

  backgroundImage: any = 'assets/images/img/partner_header_bg.png'
  @Input() sponsorOnboardingCMSData: any;

  constructor() {}
  
  ngOnInit(): void {
    
  }
}
